import { makeVar, useReactiveVar } from "@apollo/client";
import { useIsAuthenticated } from "@azure/msal-react";
import { Backdrop, CircularProgress, Typography } from "@mui/material";
import { AppRoutes } from "App.routes";
import { useAxiosInterceptor } from "error/handlers/axios-error-handler";
import { useAppBackgroundQueries } from "hooks/useAppBackgroundQueries";
import { useInitializeAuth } from "hooks/useInitializeAuth";
import { ToastContainer } from "react-toastify";
import Loading from "shared-components/Loading";
import { ReleaseNotes } from "shared-components/ReleaseNotes";
import styled from "styled-components";
const StyledBackdrop = styled(Backdrop)`
  z-index: 10000;
  color: #fff;
`;
const BackdropContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 100%;
`;
export const BackdropOpen = makeVar<{
  header?: string;
  subText?: string;
  size?: number;
  open: boolean;
}>({
  open: false,
});
function App(): JSX.Element {
  const isAuthenticated = useIsAuthenticated();
  const { loading, initialized } = useInitializeAuth();
  useAppBackgroundQueries(initialized);
  const { header, open, size, subText } = useReactiveVar(BackdropOpen);
  useAxiosInterceptor();

  if (loading || (isAuthenticated && !initialized)) {
    return <Loading name="rotating-plane" color="red" />;
  }

  return (
    <>
      <StyledBackdrop
        open={open}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <BackdropContent>
          <CircularProgress size={size} color="inherit" />
          <Typography variant={"h4"} component={"h4"}>
            {header}
          </Typography>
          <Typography variant={"h6"} component={"h6"}>
            {subText}
          </Typography>
        </BackdropContent>
      </StyledBackdrop>
      <ToastContainer />
      <AppRoutes />
      <ReleaseNotes />
    </>
  );
}

export default App;
